import deepMerge from "@helper/deepMerge";

export const LINK_SETUP = "pss/link/SETUP";
export const LINK_EXPOSE_MODULE_DATA = "pss/link/EXPOSE_MODULE_DATA";
export const LINK_REGISTER_PROCESS_INSTANCE =
  "pss/link/REGISTER_PROCESS_INSTANCE";

const initialState = { linkId: null, currentLink: null, modules: {}, activeProcessInstances: [] };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LINK_SETUP:
      return { ...initialState, ...action.payload };
    case LINK_EXPOSE_MODULE_DATA:
      return {
        ...state,
        modules: {
          ...state.modules,
          [action.payload.moduleId]: deepMerge([
            state.modules[action.payload.moduleId],
            action.payload.data,
          ]),
        },
      };
    case LINK_REGISTER_PROCESS_INSTANCE:
      return {
        ...state,
        activeProcessInstances: [
          ...state.activeProcessInstances,
          action.payload,
        ],
      };
    default:
      return state;
  }
}

export function linkSetup(currentLink) {
  return { type: LINK_SETUP, payload: { linkId: currentLink.id, currentLink } };
}

export function linkExposeModuleData(moduleId, data) {
  return { type: LINK_EXPOSE_MODULE_DATA, payload: { moduleId, data } };
}

export function linkRegisterProcessInstance(processInstanceId) {
  return { type: LINK_REGISTER_PROCESS_INSTANCE, payload: processInstanceId };
}
